import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {Address} from '@kion/data-models';

export const createAddressSuccess = createActionWithCorrelation(
  "[Address] create address success",
  props<{ address: Address }>()
);
export const createAddressError = createActionWithCorrelation(
  "[Address] create address error",
  props<{ error: any }>()
);
export const createAddress = createActionWithCorrelation(
  "[Address] create address",
  props<{ address: Partial<Address>, basketId: string, isInvoice: boolean, userId?: string }>(),
  createAddressSuccess.type,
  createAddressError.type
);

export const updateAddressSuccess = createActionWithCorrelation(
  "[Address] update address success",
  props<{ address: Address }>()
);
export const updateAddressError = createActionWithCorrelation(
  "[Address] update address error",
  props<{ error: any }>()
);
export const updateAddress = createActionWithCorrelation(
  "[Address] update address",
  props<{ addressId: string, address: Partial<Address>, userId?: string }>(),
  updateAddressSuccess.type,
  updateAddressError.type
);

export const loadAllSuccess = createActionWithCorrelation(
  "[Address] load all success",
  props<{ addresses: Address[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[Address] load all error",
  props<{ error: any }>()
);
export const loadAll = createActionWithCorrelation(
  "[Address] load all",
  loadAllSuccess.type,
  loadAllError.type
);

export const clearAddressesSuccess = createActionWithCorrelation(
  "[Address] clear address success"
);
export const clearAddressesError = createActionWithCorrelation(
  "[Address] clear address error"
);
export const clearAddresses = createActionWithCorrelation(
  "[Address] clear address",
  clearAddressesSuccess.type,
  clearAddressesError.type
);
